type Companie = {
  id: number;
  name: string;
};

export const getCompaniesAdapter: (payload: any) => Companie[] = payload => {
  return payload.map(company => ({ id: company.id, name: company.name }));
};
